import {
  Checkbox as AriaCheckbox,
  type CheckboxProps as AriaCheckboxProps,
} from 'react-aria-components'
import { CheckIcon as Check } from '@untitledui-icons/react/line'
import { cn } from '@/lib/utils'

export interface CheckboxProps extends AriaCheckboxProps {
  label?: string
  description?: string
}

export function Checkbox({
  className,
  label,
  description,
  children,
  ...props
}: CheckboxProps) {
  return (
    <AriaCheckbox
      className={cn(
        'group flex items-start gap-3 cursor-pointer',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      {({ isSelected, isIndeterminate }) => (
        <>
          <div
            className={cn(
              'flex h-5 w-5 shrink-0 items-center justify-center rounded border-2 transition-colors',
              'border-gray-300 bg-white',
              'group-hover:border-brand-500',
              'group-focus-visible:ring-2 group-focus-visible:ring-brand-500 group-focus-visible:ring-offset-2',
              'dark:bg-gray-900 dark:border-gray-600',
              (isSelected || isIndeterminate) &&
                'border-brand-500 bg-brand-500 dark:border-brand-400 dark:bg-brand-500'
            )}
          >
            {isSelected && <Check className="h-3.5 w-3.5 text-white" />}
            {isIndeterminate && (
              <div className="h-0.5 w-2.5 rounded-full bg-white" />
            )}
          </div>
          {(label || description || children) && (
            <div className="flex flex-col">
              {label && (
                <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
                  {label}
                </span>
              )}
              {description && (
                <span className="text-sm text-gray-500 dark:text-gray-400">
                  {description}
                </span>
              )}
              {children}
            </div>
          )}
        </>
      )}
    </AriaCheckbox>
  )
}

export default Checkbox
